import axios from "axios";
import { fullAPIURL, subdomain } from "../../../utils/requests";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../../../utils/axios.utils";
import {
  AuthenticateUserDataType,
  AuthenticateUserRequestType,
  FetchClientDataType,
} from "../types";

const authenticateAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/auth/`,
  headers: { "Content-Type": "application/json" },
});

const clientAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/client/`,
  headers: { "Content-Type": "application/json" },
});

export async function postAuthenticateUser({
  clientUuid,
  email,
  password,
}: AuthenticateUserRequestType) {
  const response = await authenticateAxios.post<AuthenticateUserDataType>(
    `authenticate`,
    {
      clientUuid,
      email,
      password,
    },
  );
  return response.data;
}

export async function fetchClientInfo() {
  const response = await clientAxios.get<FetchClientDataType>(
    `clients/subdomain/${subdomain}`,
  );
  return response.data;
}

authenticateAxios.interceptors.response.use(responseStatusInterceptor);

clientAxios.interceptors.request.use(requestAccessTokenInterceptor);
clientAxios.interceptors.response.use(responseStatusInterceptor);
